module.exports = __webpack_public_path__ + "static/media/kuala-lipis-logo.477f8c91.png";